import {Alert, Button, Col, message, Row, Space} from "antd";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {FullPageLoader} from "../../../../../components/full-page-loader";
import {OfferingFormAccordionItem} from "../../../../../components/offering-form/accordion/accordion-item";
import {
  useSessionCoverImagesDelete,
  useSessionUploadCoverImages,
  useCoverImagesWithFallback,
  mapDomainToEmbedded,
} from "../../../../../features/media";
import {useCreateSessionContext} from "../../context/create-session";
import {useSession} from "../../../../../features/sessions";
import {SessionCoverImagesFormFields} from "../../../../../components/offering-form/session-bundle/session/cover-images";

export function CreateSessionCoverImagesUploadStep() {
  const sessionUploadCoverImagesMutation = useSessionUploadCoverImages();
  const sessionCoverImagesDeleteMutation = useSessionCoverImagesDelete();
  const {
    dispatch,
    state: {formData, sessionData},
  } = useCreateSessionContext();

  const sessionId = sessionData?.id ?? 0;
  const sessionQuery = useSession(sessionId, sessionId > 0);

  // Fetch cover images with fallback to session's embedded data
  const {coverImages, isLoading: isCoverImagesLoading} = useCoverImagesWithFallback({
    offeringType: "service",
    offeringId: sessionQuery.data?.id,
    embedded:
      sessionQuery.data?.coverImages?.map((img) => ({
        id: img.id,
        media_url: img.url,
        media_type: "image" as const,
        offering_id: sessionQuery.data?.id ?? 0,
        offering_type: "service" as const,
        user_id: sessionQuery.data?.userId ?? 0,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      })) ?? [],
  });
  const coverImagesForDisplay = mapDomainToEmbedded(coverImages);

  if (sessionQuery.isLoading || isCoverImagesLoading) {
    return <FullPageLoader />;
  }

  if (sessionQuery.isError) {
    return (
      <Alert
        message="Error"
        description={sessionQuery.error.message}
        type="error"
        showIcon
      />
    );
  }
  function handleCoverImagesItemDelete({
    mediaId,
    offeringId,
  }: {
    mediaId: string;
    offeringId: number;
  }) {
    sessionCoverImagesDeleteMutation.mutate(
      {mediaId, offeringId},
      {
        onSuccess: () => {
          message.success("Deleted successfully");
        },
      }
    );
  }

  function handleNextStep() {
    dispatch({
      type: "update-create-session-form-step",
      payload: "automations",
    });
  }
  const session = sessionQuery.data!;

  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <OfferingFormAccordionItem key={"Cover image"} index={0} title={"Cover image"}>
          <SessionCoverImagesFormFields
            accordionIndex={0}
            sessionData={{
              id: session.id,
            }}
            defaultCoverImages={coverImagesForDisplay}
            deleteCoverImage={handleCoverImagesItemDelete}
            isDeleteLoading={sessionCoverImagesDeleteMutation.isLoading}
            isUploadLoading={sessionUploadCoverImagesMutation.isLoading}
            offeringId={session.id}
            uploadCoverImages={sessionUploadCoverImagesMutation}
          />
        </OfferingFormAccordionItem>
        <Row gutter={[0, 16]}>
          <Col span={24} sm={12}>
            <StyledServiceButtonWrapper>
              <Button
                onClick={() =>
                  dispatch({
                    type: "go-to-checkout-form-step",
                    payload: {
                      ...formData,
                    },
                  })
                }
                block
                size="small"
                type="default"
              >
                Back
              </Button>
              <Button
                block
                type="primary"
                size="small"
                onClick={handleNextStep}
                disabled={
                  sessionUploadCoverImagesMutation.isLoading ||
                  sessionCoverImagesDeleteMutation.isLoading
                }
              >
                Next
              </Button>
            </StyledServiceButtonWrapper>
          </Col>
        </Row>
      </Space>
    </div>
  );
}
